import type { AppRouteRecordRaw } from '@/router/types';
import { useI18n } from '@/hooks/web/useI18n';
import { LAYOUT } from '@/router/constant';

const { t } = useI18n();

const BigScreenRoute: AppRouteRecordRaw = {
  path: '/amp2',
  name: 'Amp2',
  component: LAYOUT,
  meta: {
    title: t('router.amp2'),
    icon: 'control-platform',
    hideBreadcrumb: true,
    hideMenu: false,
    layout: 'empty',
    orderNo: 10,
    perCode: 'kedex:amp2'
  },
  children: [
    {
      path: 'dashboard2',
      name: 'amp-dashboard2',
      component: () => import('@/views/amp2/dashboard2.vue'),
      meta: {
        title: t('router.ampDashboard'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:amp2:dashboard2'
      }
    },
    {
      path: 'project-setting2',
      name: 'amp-project-setting2',
      component: () => import('@/views/amp2/projectSetting2.vue'),
      meta: {
        title: t('router.ampSiteSurvey'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:amp2:projectSetting2'
      }
    },
    {
      path: 'system-setting2',
      name: 'amp-setting2',
      component: () => import('@/views/amp2/setting2.vue'),
      meta: {
        title: t('router.ampFactorSetting'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:amp2:systemSetting2'
      }
    },
    {
      path: 'site-manager',
      name: 'amp-site-manager',
      component: () => import('@/views/amp2/simulationManager.vue'),
      meta: {
        title: t('router.ampSimulationManager'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:amp2:simulationManager'
      }
    },
    {
      path: 'equipment-list',
      name: 'equipment-list',
      component: () => import('@/views/amp2/equipmentList.vue'),
      meta: {
        title: t('router.equipmentList'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:amp2:equipmentList'
      }
    }
  ]
};

export default BigScreenRoute;
